<template lang="pug">
v-row(align="center" class=" tw-h-24 tw-pt-2  tw-z-40" :class="appBarBg")
  v-col(cols="auto")
    template(v-if="website.logo")
      v-img(:src="path(website.logo)" class=" tw-h-16 tw-w-16 tw-mx-6")
    template(v-else)
      span(:class="titleColor" class=" tw-text-lg tw-font-bold") realtor
  v-spacer
  v-col(cols="auto" class="mr-10")
    v-row(no-gutters class=" tw--mt-3")
      v-col(cols="auto" v-if="website.pages.home.published")
        v-btn(
          small
          :to="`/website`"
          height="35px"
          exact
          text
          rounded
          elevation="0"
          color="titleColor"
          :ripple="false"
          active-class="theme-g-nav-active "
          class="tw-p-0 tw-m-0 theme-g-nav"
        ) {{ website.pages.home.name }}
      v-col(cols="auto" v-if="website.pages.rent.published")
        v-btn(
          small
          :to="`/website/${website.pages.rent.slug}`"
          height="35px"
          text
          rounded
          color="titleColor"
          :ripple="false"
          active-class="theme-g-nav-active "
          class="tw-p-0 tw-m-0 theme-g-nav"
        ) {{ website.pages.rent.name }}
      v-col(cols="auto" v-if="website.pages.buy.published")
        v-btn(
          small
          :to="`/website/sale`"
          height="35px"
          text
          rounded
          :ripple="false"
          color="titleColor"
          active-class="theme-g-nav-active "
          class="tw-p-0 tw-m-0 theme-g-nav"
        ) {{ website.pages.buy.name }}
      v-col(cols="auto" v-if="website.pages.about.published")
        v-btn(
          small
          :to="`/website/${website.pages.about.slug}`"
          height="35px"
          text
          rounded
          :ripple="false"
          color="titleColor"
          active-class="theme-g-nav-active "
          class="tw-p-0 tw-m-0 theme-g-nav"
        ) {{ website.pages.about.name }}
      v-col(cols="auto" v-if="website.pages.contact.published")
        v-btn(
          small
          :to="`/website/${website.pages.contact.slug}`"
          height="35px"
          text
          rounded
          :ripple="false"
          color="titleColor"
          active-class="theme-g-nav-active "
          class="tw-p-0 tw-m-0 theme-g-nav"
        ) {{ website.pages.contact.name }}
  v-spacer
</template>
<script>
export default {
  props: {
    appBarBg: {
      type: String,
      default: '',
    },
    titleColor: {
      type: String,
      default: 'tw-text-white',
    },
    changeOnScroll: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    website() {
      return this.$store.getters['website/website'];
    },
  },
};
</script>
<style lang="scss">
.theme-g-nav {
  font-size: 14px !important;
  font-weight: 400 !important;
  color: black !important;
}
.theme-g-nav-active .v-btn__content {
  font-weight: 900 !important;
  font-size: 14px !important;
  color: #e8c855 !important;
}
.theme-g-nav-active::before,
.theme-g-nav-active {
  opacity: 1 !important;
  background-color: transparent !important;
}
.theme-g-nav:hover::before {
  opacity: 0 !important;
}
.theme-g-header-container {
  background-color: #16222a;
}
</style>
